var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopupFilledPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#684199",
    d: "M3.03 7.5A5.98 5.98 0 0 1 7 6h18c1.521 0 2.91.567 3.97 1.5A4 4 0 0 0 25 4H7a4 4 0 0 0-3.97 3.5m0 4A5.98 5.98 0 0 1 7 10h18c1.521 0 2.91.567 3.97 1.5A4 4 0 0 0 25 8H7a4 4 0 0 0-3.97 3.5M7 12a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h18a4 4 0 0 0 4-4v-8a4 4 0 0 0-4-4h-5a1 1 0 0 0-1 1 3 3 0 0 1-6 0 1 1 0 0 0-1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopupFilledPurple);
export default __webpack_public_path__ + "static/media/topup_filled_purple.878d084db22ae63f7b19e9667f4bd081.svg";
export { ForwardRef as ReactComponent };